var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const MESSAGE_EVENT_TYPE = "m.room.message";
export function sendMessage(client, roomId, message, eventType = MESSAGE_EVENT_TYPE) {
    return __awaiter(this, void 0, void 0, function* () {
        const content = {
            body: message,
            msgtype: "m.text",
        };
        client.scheduler = undefined;
        yield client.sendEvent(roomId, eventType, content, "");
    });
}
//# sourceMappingURL=matrixUtil.js.map